import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'search'
})
export class SearchPipe implements PipeTransform {

  transform(value: any[], args: any, page) {

    if( args.length === 0 ){
      return value.slice(page,page+7)
    }

    let result = []
    
    value.forEach(item => {
       if( item.documento.toLowerCase().includes(args.toLowerCase())   ||  item.user_name.toLowerCase().includes(args.toLowerCase())  ){
          result.push(item)
       }
    });
    return result;
  }

  

}
